export default "__VITE_ASSET__Bz981sfw__"